module.exports = __webpack_public_path__ + "static/media/Gorey.b7bf80a9.ttf";